import React from 'react';
import { connect } from 'react-redux';

import { PromoButton } from 'apps/promo/components/common/promo-button/PromoButton';
import { PromoCountriesColumns } from 'apps/promo/components/common/promo-countries/PromoCountriesColumns';
import PromoCountryItem from 'apps/promo/components/common/promo-countries/PromoCountryItem';
import HeadingSection from 'apps/promo/components/common/sections/HeadingSection';
import { getLangCountryPrefix } from 'apps/promo/helpers/utils';

const GeoSection = (props) => {
    const isSendOperation = props.calculatorOperation === 'send';
    const availableCountries = props.geoData.filter((country) => country[isSendOperation ? 'receive' : 'send']);

    const getList = () => {
        return availableCountries.map((supportedCountry) => {
            return (
                <li key={supportedCountry.code}>
                    <PromoCountryItem
                        countryCode={supportedCountry.code.toLowerCase()}
                        name={supportedCountry.name}
                        senderSlug={supportedCountry.senderSlug}
                        receiverSlug={supportedCountry.receiverSlug}
                        urlTemplate={props.urlTemplate}
                        isSendOperation={isSendOperation}
                        isGeoSection
                    />
                </li>
            );
        });
    };

    if (!props.geoData) {
        return <></>;
    }

    return (
        <>
            {(props.headlineSupportedCountriesRestrictionsTitle || props.headlineSupportedCountriesRestrictionsText) && (
                <HeadingSection title={props.headlineSupportedCountriesRestrictionsTitle} text={props.headlineSupportedCountriesRestrictionsText} />
            )}
            <PromoCountriesColumns>{getList()}</PromoCountriesColumns>
            <PromoButton
                variant="tertiary"
                type="link"
                href={`${getLangCountryPrefix(props.lang, props.country)}${props.learnMoreUrl}`}
                caption={props.learnMore}
                iconName="arrow-right"
            />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        calculatorOperation: state.extra?.strapiApi?.calculator.operation,
        geoData: state.extra?.strapiApi?.calculator?.countries,
        urlTemplate: state.extra?.strapiApi?.calculator?.supportedCountriesUrlTemplate,
        headlineSupportedCountriesRestrictionsTitle: state.extra?.strapiApi?.headlineSupportedCountriesRestrictions?.title,
        headlineSupportedCountriesRestrictionsText: state.extra?.strapiApi?.headlineSupportedCountriesRestrictions?.text,
        learnMore: state.extra?.strapiApi?.buttonSupportedCountries?.title,
        learnMoreUrl: state.extra?.strapiApi?.buttonSupportedCountries?.url,
        lang: state.language.lang,
        country: state.app.country,
    };
};
export default connect(mapStateToProps)(GeoSection);
